module.exports = __webpack_public_path__ + "img/cattunnel04.16cf20b5.jpg";